module.exports = __webpack_public_path__ + "static/media/logo.adb51c75.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.png
// module id = 2026
// module chunks = 0